import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';

const DownloadFiles30 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial30/tutorial30.zip?ref_type=heads&inline=false', download: 'tutorial30.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialThirty= () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How to Create Interactive Graphs with Trend Lines Using Checkboxes | Qtdesigner | Python3 | PyQt6</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/lyTurbqrzs0/maxresdefault.jpg"
                            alt="Tutorial 30"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    In this PyQt6 tutorial, you'll learn how to create interactive graphs with trend lines controlled by checkboxes using QtDesigner and Python3. This step-by-step guide will teach you how to make visually appealing graphs where users can toggle trend lines on and off, providing an engaging and customizable data visualization experience.
                        <br /><strong>What You'll Learn:</strong>
                        <ul>
                            <li>Setting up PyQt6 with QtDesigner for graph plotting</li>
                            <li>Integrating PyQtGraph into your PyQt6 application</li>
                            <li>Creating trend lines on graphs</li>
                            <li>Connecting checkboxes to control the visibility of trend lines</li>
                            <li>Building interactive and user-friendly data visualizations</li>
                        </ul>

                        By the end of this tutorial, you'll be able to turn static data into dynamic and interactive graphs, making your projects stand out!
                        <br /><br />
                        #Python #PyQt6 #QtDesigner #PyQtGraph #DataVisualization #GUI #InteractiveGraphs #TrendLines #PythonProgramming #DesktopAppDevelopment #GraphPlotting #DataAnalysis #ProgrammingTutorials
                    </p>

                    <button className="seemore">
                        <DownloadFiles30 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialThirty;
